export default __webpack_public_path__ + "static/media/black2.bb4e0d4d.gif";